import { render, staticRenderFns } from "./supplierCostEntry.vue?vue&type=template&id=58893395&scoped=true"
import script from "./supplierCostEntry.vue?vue&type=script&lang=js"
export * from "./supplierCostEntry.vue?vue&type=script&lang=js"
import style0 from "./supplierCostEntry.vue?vue&type=style&index=0&id=58893395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58893395",
  null
  
)

export default component.exports